import PropTypes from "prop-types";
import SEPA from "sepa";
import { TextField as Field } from "@mui/material";
import { useController } from "react-hook-form";
import { formatIBAN } from "../../../utils/dataUtils";
import { useState } from "react";

//---------------------------------------------------------------------------------
IBANTextField.propTypes = {
  control: PropTypes.object,
  style: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMsg: PropTypes.string,
  multiline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
};

//---------------------------------------------------------------------------------

export default function IBANTextField({
  control,
  style,
  name,
  label,
  errorMsg,
  multiline,
  fullWidth,
  disabled,
  type,
  setError,
  clearErrors,
  required,
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: {
      required: required,
      validate: (value) => {
        const normalizedValue = String(value || "").replace(/\s+/g, "");
        if (!normalizedValue) return true;
        return SEPA.validateIBAN(normalizedValue) || "IBAN ungültig!";
      },
    },
  });
  const [valid, setValid] = useState(false);

  const handleIBANChange = (event) => {
    let value = event.target.value.toUpperCase();
    const formattedValue = formatIBAN(value);
    const normalizedValue = formattedValue.replace(/\s+/g, "");
    if (!normalizedValue) {
      setValid(false);
    } else {
      const ibanIsValid = SEPA.validateIBAN(normalizedValue);
      setValid(ibanIsValid);
      if (setError && clearErrors) {
        if (!ibanIsValid) {
          setError(field.name, { type: "custom", message: "IBAN ungültig!" });
        } else {
          clearErrors(field.name);
        }
      }
    }
    field.onChange(formattedValue);
  };

  const handleBlur = (e) => {
    const normalizedValue = String(e.target.value || "").replace(/\s+/g, "");
    if (!normalizedValue) {
      setValid(false);
    } else {
      const ibanIsValid = SEPA.validateIBAN(normalizedValue);
      setValid(ibanIsValid);
      if (setError && clearErrors) {
        if (!ibanIsValid) {
          setError(field.name, { type: "custom", message: "IBAN ungültig!" });
        } else {
          clearErrors(field.name);
        }
      }
    }
    field.onBlur(e);
  };

  return (
    <Field
      label={label}
      variant="outlined"
      required={Boolean(required)}
      onChange={handleIBANChange} // send value to hook form
      onBlur={handleBlur} // notify when input is touched/blur
      value={field.value} // input value
      name={field.name} // send down the input name
      inputRef={field.ref} // send input ref, so we can focus on input when error appear
      error={error && true}
      helperText={error && error.message}
      fullWidth={fullWidth}
      disabled={disabled}
      multiline={multiline}
      style={style}
      type={type}
      focused={valid}
      color={valid ? "success" : ""}
    />
  );
}

IBANTextField.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMsg: PropTypes.string,
  style: PropTypes.object,
  multiline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

IBANTextField.defaultProps = {
  type: "text", // Hier den Standardwert festlegen
};

// // Sample Input:
// {/* <IBANTextField
// control={control}
// name={iban}
// label={IBAN}
// type={text}
// variant="outlined"
// required={true}
// fullWidth
// setError={setError}
// clearErrors={clearErrors}
// /> */}
